/**
 * These context values matter when pulling for Engagement Score summaries for group and organization.
 */
export const Context = {
  GROUP: 'groups',
  ORGANIZATION: 'organizations'
}
